var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-icon',{staticClass:"fas fa-calendar-alt icon-calendar mr-4"}),_c('span',{staticClass:"timer"},[_vm._v(_vm._s(_vm.timer))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }